var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchPairBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 128,
    viewBox: "0 0 95 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1856 115.323L100.68 123.462L129.999 27.7809L29.3186 0L0 95.6808L58.9767 111.954V130H71.1856V115.323ZM71.1856 103.214L92.4266 109.081L114.867 35.7067L37.6584 14.3807L15.2181 87.7551L58.9767 99.8417V76.1539H71.1856V103.214ZM73.9369 61.7732C73.9369 57.0341 70.0679 53.3572 65.0811 53.3572C60.1804 53.3572 56.3114 57.0341 56.2254 61.7732C56.2254 66.5123 60.0944 70.1892 65.0811 70.1892C70.0679 70.1892 73.9369 66.5123 73.9369 61.7732Z",
    fill: "#E7F0FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchPairBg);
export default __webpack_public_path__ + "static/media/match_pair_bg.1d54dadfa281a8e668f2b1e0872e2e0b.svg";
export { ForwardRef as ReactComponent };